module.exports = __webpack_public_path__ + "img/guizhou.aeab41e3.jpg";